import { render, staticRenderFns } from "./Boton3HistorialEstadosAcademicos.vue?vue&type=template&id=5ee3b87f"
import script from "./Boton3HistorialEstadosAcademicos.vue?vue&type=script&lang=js"
export * from "./Boton3HistorialEstadosAcademicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports